import { createContext } from 'react'

import { IamStateContextType, IamDispatchContextType } from './IamContext.types'

export const IamStateContext = createContext<IamStateContextType | undefined>(undefined)
export const IamDispatchContext = createContext<IamDispatchContextType | undefined>(undefined)
